export enum WineColor {
  Red = 1,
  Rose = 2,
  White = 3
}

(WineColor as any).__typeName = 'WineColor';

